// Single source of truth for the "main source of funds" values — shared
// between this datasource's SourceOfFundsType and the KYC Source of Funds
// screen's option ids (see KycSourceOfFunds/constants), which used to keep
// its own separate literal list that had to be manually kept in sync.
export const SOURCE_OF_FUNDS_VALUES = [
  'paycheck',
  'government_benefits',
  'retirement',
  'cash',
  'other',
] as const;

export type SourceOfFundsType = (typeof SOURCE_OF_FUNDS_VALUES)[number];
